import { render, staticRenderFns } from "./SideModalComments.vue?vue&type=template&id=f5b14684&"
import script from "./SideModalComments.vue?vue&type=script&lang=js&"
export * from "./SideModalComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports